/**
 * @generated SignedSource<<abb889f860bf8a0d6a6f2f226bfd0403>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateCategorySectionRelayFragment$data = {
  readonly categories: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null | undefined;
    readonly urlSlug: string | null | undefined;
  }> | null | undefined;
  readonly templateType: ReadonlyArray<{
    readonly id: string;
    readonly templateTypeName: string | null | undefined;
  }> | null | undefined;
  readonly " $fragmentType": "templateCategorySectionRelayFragment";
};
export type templateCategorySectionRelayFragment$key = {
  readonly " $data"?: templateCategorySectionRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateCategorySectionRelayFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateCategorySectionRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTaxonomyTemplateType",
      "kind": "LinkedField",
      "name": "templateType",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateTypeName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "categories",
      "args": null,
      "concreteType": "ContentPlatformCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlSlug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplate",
  "abstractKey": null
};
})();

(node as any).hash = "b09623b07f22b7e206b9416ef23e1799";

export default node;
